import { FadeUp } from "@/components/Reveal";

export default function Testimonial() {
  return (
    <section data-testid="testimonial-section" className="relative bg-blush py-32 sm:py-44 overflow-hidden">
      <div className="absolute -top-24 left-1/4 w-[420px] h-[420px] rounded-full bg-ivory/20 blur-[100px]" aria-hidden="true" />
      <div className="max-w-4xl mx-auto px-6 sm:px-10 text-center relative">
        <FadeUp>
          <span className="font-serif text-8xl leading-none text-ivory/60 block mb-4" aria-hidden="true">"</span>
          <blockquote className="font-quote italic font-medium text-ink text-2xl sm:text-3xl lg:text-4xl leading-snug">
            OMG, I ABSOLUTELY LOVE IT! Next year, we're calling the event
            The Fantasy Runway Ball!
          </blockquote>
          <div className="mt-12 flex items-center justify-center gap-4">
            <span className="w-10 h-px bg-ink/40" />
            <p className="text-[12px] tracking-[0.4em] uppercase text-ink/70">Amanda Vargus</p>
            <span className="w-10 h-px bg-ink/40" />
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
